import { RouteRecordRaw } from 'vue-router';
import { CommonRoutesName } from '../constants/routesName';
import { getDefaultRouteForUser } from '../guards/authGuard';
import { useUserStore } from '@/common/stores/userStore';
import LoginPage from '@/features/common/auth/views/LoginPage.vue';
import { ROUTE_CATEGORY } from '../types';
const ConfigTestPage = () => import('@/views/ConfigTestPage.vue');
const NotAllowedPage = () => import('@/features/common/auth/views/NotAllowedPage.vue');
const SettingsPage = () => import('@/features/settings/views/SettingsPage.vue');
const NoRolePage = () => import('@/features/homepage/views/NoRolePage.vue');
const NotFoundPage = () => import('@/views/NotFoundPage.vue');
const PagesMetiersPage = () => import('@/features/pages-metiers/views/PagesMetiers.vue');
const ProfilePage = () => import('@/features/profile/views/Profile.vue');

/**
 * Routes communes accessibles à tous les utilisateurs
 */
export const commonRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home',
  },
  {
    path: '/login',
    name: CommonRoutesName.Login,
    component: LoginPage,
    meta: {
      title: 'routes.login',
      hideInMenu: true,
      category: ROUTE_CATEGORY.COMMON,
    },
  },
  {
    path: '/not-allowed',
    name: CommonRoutesName.NotAllowed,
    component: NotAllowedPage,
    meta: {
      title: 'routes.notAllowed',
      hideInMenu: true,
      category: ROUTE_CATEGORY.COMMON,
    },
  },
  {
    path: '/settings',
    name: CommonRoutesName.Settings,
    component: SettingsPage,
    meta: {
      title: 'routes.settings',
      icon: 'cog-outline',
      category: ROUTE_CATEGORY.COMMON,
    },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: {
      title: 'routes.profile',
      icon: 'person-circle-outline',
      category: ROUTE_CATEGORY.COMMON,
    },
  },
  {
    path: '/home',
    name: CommonRoutesName.Home,
    component: NoRolePage,
    beforeEnter: () => {
      // If the user has a role, redirect to their role-specific homepage
      const userStore = useUserStore();
      const roleRoute = getDefaultRouteForUser(userStore.userRoles);
      if (roleRoute !== '/') {
        return roleRoute;
      }
      // No role → stay on NoRolePage
    },
    meta: {
      title: 'routes.home',
      icon: 'home-outline',
      category: ROUTE_CATEGORY.COMMON,
    },
  },
  {
    path: '/config-test',
    name: CommonRoutesName.ConfigTest,
    component: ConfigTestPage,
    meta: {
      title: 'routes.configTest',
      icon: 'settings-outline',
      category: ROUTE_CATEGORY.COMMON,
    },
  },
  {
    path: '/business/:id',
    name: CommonRoutesName.Business,
    component: PagesMetiersPage,
    meta: {
      title: 'routes.business',
      requiresAuth: true,
      category: ROUTE_CATEGORY.COMMON,
      hideInMenu: true,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: CommonRoutesName.NotFound,
    component: NotFoundPage,
    meta: {
      title: 'routes.notFound',
      hideInMenu: true,
      category: ROUTE_CATEGORY.COMMON,
    },
  },
];
